export const TEST_ASSIGN_OPTIONS = ["sample", "stream"];
